import React, {Fragment} from 'react'
import { Link } from 'react-router-dom'
import Navbar from '../Navbar'
import PageTitle from '../pagetitle'
import BookingForm from '../BookingForm'
import Footer from '../footer'
import Scrollbar from '../scrollbar'
import advancedTajweedImg from '../../images/service/service/Tajweed Improvement.webp'
import tajweedDetail from '../../images/service/service-sub-pages/Tajweed Improvement.jpg'
import banner3 from '../../images/banners/3.webp'
import './style.css'

const TajweedImprovement = () => {
    const ClickHandler = (e) => {
        const hash = e.currentTarget.hash;
        if (hash === '#booking-form') {
            e.preventDefault();
            const element = document.getElementById('booking-form');
            if (element) {
                element.scrollIntoView({ behavior: 'smooth' });
            }
        } else {
            window.scrollTo(10, 0);
        }
    }

    return (
        <Fragment>
            <Navbar/>
            <PageTitle pageTitle={'Tajweed Improvement'} pagesub={'Service'} backgroundImage={banner3} hideText={true}/>
            <section className="service-single-section section-padding">
                <div className="container">
                    <div className="row">
                        <div className="col col-lg-8 col-md-12 col-12">
                            <div className="service-single-content">
                                <div className="service-single-img">
                                    <img src={advancedTajweedImg} alt="Advanced Tajweed - Perfecting Quran Recitation"/>
                                </div>
                                <h2 className="service-title"> <span>Tajweed Improvement</span> <br/> (Advanced Recitation)</h2>
                                <div className="service-description">
                                    <p>Elevate your Quran recitation to new heights with our Advanced Tajweed Improvement course. Designed for students who have already mastered basic Tajweed rules, this specialized program helps refine your technique, address persistent challenges, and develop exceptional fluency and expressiveness in your recitation.</p>
                                </div>
                                
                                <div className="service-single-inner">
                                    <span><img src={tajweedDetail} alt="Detailed Tajweed Rules"/></span>
                                    <div className="service-single-tb-text">
                                        <h3 className="service-section-title"><i className="fi flaticon-book"></i> Course Content</h3>
                                        <ul className="service-features-list">
                                            <li>Analysis of student's Tajweed - thorough assessment and personalized improvement plan</li>
                                            <li>Pronunciations - refining and perfecting articulation of challenging letter combinations</li>
                                            <li>Rules of Tajweed - deepening understanding of advanced principles</li>
                                            <li>Recitation - developing fluency, melody, and expression</li>
                                            <li>Advanced Tajweed concepts with special focus on subtle pronunciation nuances</li>
                                            <li>Intensive practice sessions on challenging verses and complex letter combinations</li>
                                            <li>Melodious recitation techniques (Maqamat) and voice modulation</li>
                                            <li>Special rules applied in different Qiraat (recitation styles)</li>
                                            <li>Precision training for perfect letter articulation</li>
                                        </ul>
                                    </div>
                                </div>
                                
                                <div className="service-section">
                                    <h3 className="service-section-title"><i className="fi flaticon-teacher"></i> Recommended Format</h3>
                                    <div className="service-section-content">
                                        <p>While we offer this course in both one-to-one and small group settings, we strongly recommend individual sessions for advanced Tajweed improvement. One-to-one classes allow for:</p>
                                        <ul className="service-features-list">
                                            <li>Personalized attention to your specific pronunciation challenges</li>
                                            <li>Customized pacing according to your strengths and areas for improvement</li>
                                            <li>Immediate feedback and detailed corrections</li>
                                            <li>More intensive practice of difficult passages</li>
                                        </ul>
                                    </div>
                                </div>
                                
                                <div className="service-section">
                                    <h3 className="service-section-title"><i className="fi flaticon-calendar"></i> Flexible Scheduling</h3>
                                    <div className="service-section-content">
                                        <p>Our scheduling is designed to fit into your busy life:</p>
                                        <ul className="service-features-list">
                                            <li>Weekly classes</li>
                                            <li>Options for more frequent sessions during intensive training periods</li>
                                            <li>Scheduling tailored to your availability</li>
                                            <li>Recording options to review your lessons between sessions</li>
                                        </ul>
                                    </div>
                                </div>
                                
                                <div className="service-section">
                                    <h3 className="service-section-title"><i className="fi flaticon-money-bag"></i> Course Fees</h3>
                                    <div className="service-section-content">
                                        <div className="pricing-table">
                                            <div className="pricing-option">
                                                <h4>3 Days per Week</h4>
                                                <div className="price">£30<span>/month</span></div>
                                                <p>Perfect for maintaining steady improvement</p>
                                            </div>
                                            <div className="pricing-option featured">
                                                <h4>4 Days per Week</h4>
                                                <div className="price">£40<span>/month</span></div>
                                                <p>Optimal for significant progress</p>
                                            </div>
                                            <div className="pricing-option">
                                                <h4>5 Days per Week</h4>
                                                <div className="price">£50<span>/month</span></div>
                                                <p>Comprehensive training for rapid mastery</p>
                                            </div>
                                        </div>
                                        <p className="pricing-note">All packages include expert advanced instruction, detailed personalized feedback, and access to specialized learning materials. Discounts available for students continuing from our basic Tajweed course.</p>
                                    </div>
                                </div>
                                
                                <div className="service-section">
                                    <h3 className="service-section-title"><i className="fi flaticon-lotus"></i> Benefits of Advanced Tajweed Training</h3>
                                    <div className="service-section-content">
                                        <ul className="service-features-list">
                                            <li>Significantly increased recitation confidence and fluency</li>
                                            <li>Elimination of deeply ingrained pronunciation errors</li>
                                            <li>Development of a more melodious and expressive recitation style</li>
                                            <li>Preparation for Quranic competitions or public recitation</li>
                                            <li>Readiness to pursue specialized Quranic studies or teaching qualifications</li>
                                            <li>Enhanced understanding of the linguistic beauty of the Quran</li>
                                        </ul>
                                    </div>
                                </div>
                                
                                <div className="service-conclusion">
                                    <p>This advanced course is perfect for students who want to perfect their recitation and achieve excellence in Tajweed. Our expert tutors provide meticulous guidance, helping you refine even the most subtle aspects of your pronunciation. Through focused practice and expert feedback, you'll develop a recitation style that honors the Quran's linguistic perfection and melodic beauty.</p>
                                </div>
                                
                                <div className="btns text-center mt-5">
                                    <Link onClick={ClickHandler} to="/home#booking-form" className="theme-btn">Book a Free Trial Class</Link>
                                </div>
                            </div>
                            
                            <div className="prv-nx">
                                <div className="pre-btn"><Link onClick={ClickHandler} to="/tajweed">Previous: Tajweed</Link></div>
                                <div className="nex-btn"><Link onClick={ClickHandler} to="/hifz">Next: Hifz (Quran Memorisation)</Link></div>
                            </div>
                        </div>
                        
                        <div className="col col-lg-4 col-md-12 col-12">
                            <div className="service-sidebar">
                                <div className="widget service-list-widget">
                                    <h3>All Services</h3>
                                    <ul>
                                        <li><Link onClick={ClickHandler} to="/basic-qaida">Basic Qaida (Beginner Quran Reading)</Link></li>
                                        <li><Link onClick={ClickHandler} to="/tajweed">Tajweed (Quran Recitation Rules)</Link></li>
                                        <li className="current"><Link to="/tajweed-improvement">Tajweed Improvement (Advanced)</Link></li>
                                        <li><Link onClick={ClickHandler} to="/hifz">Hifz (Quran Memorisation)</Link></li>
                                        <li><Link onClick={ClickHandler} to="/class-options">Class Options</Link></li>
                                        <li><Link onClick={ClickHandler} to="/free-demo">Free Demo Class</Link></li>
                                        <li><Link onClick={ClickHandler} to="/assessments">Assessments & Certification</Link></li>
                                    </ul>
                                </div>
                                <div className="widget contact-widget">
                                    <div>
                                        <h4>Book Your Free Trial Class</h4>
                                        <h2><a href="https://wa.me/message/UTB4XLJQLZ22M1">+44 784 035 7821</a></h2>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <BookingForm/>
            <Footer footerClass={'wpo-ne-footer-2'}/>
            <Scrollbar/>
        </Fragment>
    )
}

export default TajweedImprovement; 